export const removeHiddenClassBody = () => document.querySelector(`body`).classList.remove(`overflowHidden`);
